<template>
  <div v-if="show">
    <div v-for="(message_data, key) in messages" :key="key">
      <message-box :class="message_data.message_type">{{ message_data.message_text }}</message-box>
    </div>

  </div>
</template>

<script>

import { SimpleStore } from '../simplestore';
import MessageBox from "./MessageBox.vue";

export default {
  name: 'FlashMessage',
  components: {MessageBox},
  data() {
    return {
      SimpleStore,
      show: false,
      messages: [],
    }
  },
  mounted() {
    this.refresh();
  },
  methods: {
    refresh() {
      this.messages = SimpleStore.getFlashMessages();
      SimpleStore.flushFlashMessages();
      this.show = true;
    }
  }
}
</script>

<style scoped>
</style>